import { inject } from 'aurelia';
import { IRouter } from '@aurelia/router';
import { SchedulerModel } from '../../model/scheduler-model';
import { ScheduleRowEntity } from '../../apis/schedule/schedule-row-entity';
import { CustomIntervalEntity } from '../../apis/custom-interval/custom-interval-entity';
import { TeamSettingEntity } from '../../apis/team/team-setting-entity';
import { SerieSettingEntity } from '../../apis/serie/serie-setting-entity';
import { VenueEntity } from '../../apis/venue/venue-entity';
import { SchedulerModelService } from '../../services/scheduler-model-service';
import { ProjectModelService } from '../../services/project-model-service';
import { ScheduleFieldEntity } from '../../apis/schedule/schedule-field-entity';
import { GroupEntity } from '../../apis/group/group-entity';

@inject(IRouter, SchedulerModelService, ProjectModelService)
export class ReviewSchedule {
    private _router: IRouter;
    private _schedulerModel: SchedulerModel = null;
    private _schedulerModelService: SchedulerModelService;
    private _projectModelService: ProjectModelService;

    constructor(router: IRouter, schedulerModelService: SchedulerModelService, projectModelService: ProjectModelService) {
        this._router = router;
        this._schedulerModelService = schedulerModelService;
        this._projectModelService = projectModelService;
    }

    public canLoad(): boolean {
        if (!this._schedulerModelService.isLoaded) {
            setTimeout(() => void this._router.load('create'), 0);
            return false;
        }
        return true;
    }

    public loading(): void {
        this._schedulerModel = this._schedulerModelService.model;
    }

    public get games(): ScheduleRowEntity[] {
        return this._schedulerModel.games;
    }

    public get customIntervals(): CustomIntervalEntity[] {
        return this._schedulerModel.customIntervals;
    }

    public get teamSettings(): TeamSettingEntity[] {
        return this._schedulerModel.teamSettings;
    }
    public get serie(): SerieSettingEntity {
        return this._schedulerModel.serie;
    }

    public get venues(): VenueEntity[] {
        return this._projectModelService.getVenuesForEvent();
    }

    public get fields(): ScheduleFieldEntity[] {
        return this._projectModelService.getFieldsForSchedule(this._schedulerModel.scheduleId);
    }

    public get groups(): GroupEntity[] {
        return this._projectModelService.currentModel?.groups ?? [];
    }
    public get isNew(): boolean {
        return this._schedulerModel.scheduleId == null;
    }

    public get showCancel(): boolean {
        return true;
    }

    public previous(): void {
        void this._router.load('create/customize-schedule');
    }
    public cancel(): void {
        void this._router.load(`create/event-summary/${this._schedulerModel.eventId}`);
    }
    public done(): void {
        this._projectModelService.finalizeSchedule(this._schedulerModel);
        void this._router.load(`create/event-summary/${this._schedulerModel.eventId}`);
    }
}
